import apiClient from './api';
import { API_ENDPOINTS } from '@/config/api.config';
import type { SaveAIModelSettings } from '@/types/ai-model-settings.types';

class AIModelSettingsService {
  // Available models grouped by category — drives the dropdowns.
  async getCatalog() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.AI_MODEL_SETTINGS.CATALOG);
      return response.data;
    } catch (error) {
      console.error('Error fetching AI model catalog:', error);
      throw error;
    }
  }

  // Current tenant selection (defaults filled in by the backend).
  async getSettings() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.AI_MODEL_SETTINGS.GET);
      return response.data;
    } catch (error) {
      console.error('Error fetching AI model settings:', error);
      throw error;
    }
  }

  // Upsert the selection (partial — only changed features need be sent).
  async saveSettings(settingsData: SaveAIModelSettings) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.AI_MODEL_SETTINGS.UPDATE, settingsData);
      return response.data;
    } catch (error) {
      console.error('Error saving AI model settings:', error);
      throw error;
    }
  }
}

export const aiModelSettingsService = new AIModelSettingsService();
